<template>
  <div class="pl-5 pr-5 mt-5">
    <div class="title">
      <v-icon class="indent pr-1">mdi-square-medium</v-icon>
      <span class="">PCS - PHP Communication Services</span>
    </div>

    <div class="font-weight-light mt-3">
      <p>
        V tomto případě nejde o webovou aplikaci. PCS je aplikace, která běží na pozadí jako služba (daemon)
        a zprostředkovává předávání dat a povelů mezi databázemi a klientskými aplikacemi. Umí komunikovat pomocí
        protokolů TCP, UDP, UNIX a WebSocket.
      </p>
      <p>
        Základem aplikace je jádro, které zajišťuje správu běžícího daemonu a komunikaci, k jádru se pak
        přidávají moduly, které jsou součásti klientských aplikací a zajišťují správu předávaných dat
        a povelů. Tuto službu využívají pro komunikaci např. výše popsané aplikace KDS, Administrační
        konzole a Spectu konektor.
      </p>
      <p>
        Aplikace je psána v PHP na výslovný požadavek zákazníka, přesto je rychlá, nenáročná na čas procesoru
        a paměť a spolehlivá.
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Pcs"
  }
</script>

<style scoped>
  .indent {
    margin-left: -7px;
    margin-top: -2px;
  }
</style>